import { render, staticRenderFns } from "./OfferDeletionSoft.vue?vue&type=template&id=727b0e64&"
import script from "./OfferDeletionSoft.vue?vue&type=script&lang=js&"
export * from "./OfferDeletionSoft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports